"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Badge_styled_exports = {};
__export(Badge_styled_exports, {
  StyledBadge: () => StyledBadge,
  StyledBadgeContainer: () => StyledBadgeContainer,
  StyledIcon: () => StyledIcon
});
module.exports = __toCommonJS(Badge_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_Icon = require("../Icon/Icon.component");
var import_mixins = require("../../../themes/mixins");
var StyledBadge = (0, import_styled_components.default)(import_styled_components.default.div.withConfig({
  displayName: "Badgestyled__StyledBadge",
  componentId: "sc-1m2bv90-1"
})([""])).withConfig({
  displayName: "Badgestyled__StyledBadge",
  componentId: "sc-1m2bv90-0"
})(function(_ref) {
  var icon = _ref.icon, text = _ref.text, theme = _ref.theme, badgeType = _ref.badgeType, badgeColor = _ref.badgeColor, customStyles = _ref.customStyles;
  var colorMap = {
    transparent: "transparent",
    beige: theme.colors.beige[120],
    khaki: theme.colors.khaki[120],
    olive: theme.colors.olive[120],
    orange: theme.colors.terracotta[120],
    pr: theme.colors.pr[120],
    white: theme.colors.white
  };
  var paddings = {
    onlyIcon: (0, import_styled_components.css)(["", ""], (0, import_mixins.withPadding)("extraSmall extraSmall extraSmall zero")),
    onlyText: (0, import_styled_components.css)(["", ""], (0, import_mixins.withPadding)("small medium")),
    "default": (0, import_styled_components.css)(["", ""], (0, import_mixins.withPadding)("small medium small medium"))
  };
  var variantMixin = function variantMixin2() {
    return (0, import_styled_components.css)(["background-color:", ";height:20px;line-height:21px;margin-left:5px;", " span{display:flex;align-items:center;vertical-align:middle;}"], colorMap[badgeColor], customStyles);
  };
  var addCustomStyles = function addCustomStyles2() {
    return (0, import_styled_components.css)(["border-radius:var(--gma-atm-badge-border-radius);background-color:var(--gma-atm-badge-background,", ");border:1px solid var(--gma-atm-badge-border);color:var(--gma-atm-badge-color,'black');height:var(--gma-atm-badge-height,'20px');line-height:var(--gma-atm-badge-height,'21px');"], colorMap[0]);
  };
  var setPaddings = function setPaddings2() {
    if (text && icon) {
      return paddings["default"];
    }
    if (icon && !text) {
      return paddings.onlyIcon;
    }
    return text.length > 1 ? paddings.onlyText : (0, import_styled_components.css)(["padding:3px 9px;"]);
  };
  var variantStyles = {
    round: (0, import_styled_components.css)(["border-radius:24px;", ""], variantMixin()),
    "squared-round": (0, import_styled_components.css)(["border-radius:4px;", ""], variantMixin())
  };
  return (0, import_styled_components.css)(["align-items:center;border:none;color:", ";cursor:default;display:inline-flex;font-family:", ";font-size:", ";font-weight:", ";line-height:16px;letter-spacing:0.5px;text-align:center;text-transform:uppercase;", " ", " ", ""], theme.colors.n[100], theme.typography.fonts.primary, theme.typography.sizes.extraSmall, theme.typography.weights.regular, setPaddings(), badgeType && variantStyles[badgeType], customStyles && addCustomStyles());
});
var StyledIcon = (0, import_styled_components.default)(import_Icon.Icon).withConfig({
  displayName: "Badgestyled__StyledIcon",
  componentId: "sc-1m2bv90-2"
})(function(_ref2) {
  var theme = _ref2.theme, icon = _ref2.icon, text = _ref2.text;
  return (0, import_styled_components.css)(["letter-spacing:0px;line-height:", ";padding:", ";padding-right:", ";"], icon && text ? "1px" : void 0, icon && !text ? theme.measurements.extraSmall : theme.measurements.zero, icon && text ? theme.measurements.small : theme.measurements.zero);
});
var StyledBadgeContainer = import_styled_components.default.div.withConfig({
  displayName: "Badgestyled__StyledBadgeContainer",
  componentId: "sc-1m2bv90-3"
})(["margin-bottom:5px;display:flex;align-items:center;"]);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledBadge,
  StyledBadgeContainer,
  StyledIcon
});
//# sourceMappingURL=Badge.styled.js.map